/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Backbone from 'backbone';

import AWPackageFundingSources from '@/enums/AWPackageFundingSources';

import GetAWPackageInformation from '../services/GetAWPackageInformation';
import CalculateAWPackageDeviceCount from '../services/CalculateAWPackageDeviceCount';
import GetAllContractExtensionTypes from '../services/GetAllContractExtensionTypes';
import GetAWPackageFDRInfo from '../services/GetAWPackageFDRInfo';
import GetAWPackage1901Info from '../services/GetAWPackage1901Info';
import GetAllRegions from '../../common/services/GetAllRegions';
import GetAllAWPackageFundingCategories from '../services/GetAllAWPackageFundingCategories';
import AWPackageFDRInformationView from '../views/AWPackageFDRInformationView';
import AWPackage1901InformationView from '../views/AWPackage1901InformationView';
import AWPackageAdditionalInformationView from '../views/AWPackageAdditionalInformationView';
import GetActiveKOInformationByRegionGroupID from '../services/GetActiveKOInformationByRegionGroupID';

export default async function loadAWPackageAdditionalInformationView({ awPackageId, editable, showValidation }) {
  const [awPackage, deviceCount, contractExtensionTypes, allRegions] = await Promise.all([
    GetAWPackageInformation(awPackageId),
    CalculateAWPackageDeviceCount(awPackageId),
    GetAllContractExtensionTypes(),
    GetAllRegions()
  ]);

  awPackage.deviceCount = deviceCount;

  if (awPackage.fundingSourceId === AWPackageFundingSources.FDR) {
    // FDR
    const [awPackageFDRInfo, fundingCategories, koDefaults] = await Promise.all([
      GetAWPackageFDRInfo(awPackageId),
      GetAllAWPackageFundingCategories(),
      GetActiveKOInformationByRegionGroupID(awPackage.regionGroupId)
    ]);
    return new AWPackageFDRInformationView({
      model: new Backbone.Model({
        awPackage,
        contractExtensionTypes,
        editable,
        awPackageFDRInfo,
        allRegions: allRegions.filter((region) => region.isSpecialty === 'false'),
        fundingCategories,
        showValidation,
        koDefaults
      })
    });
  } else if (awPackage.fundingSourceId === AWPackageFundingSources['1901']) {
    // 1901
    const awPackage1901Info = await GetAWPackage1901Info(awPackageId);
    return new AWPackage1901InformationView({
      model: new Backbone.Model({
        awPackage,
        contractExtensionTypes,
        editable,
        awPackage1901Info,
        allRegions: allRegions.filter((region) => region.isSpecialty === 'false'),
        showValidation
      })
    });
  } else {
    return new AWPackageAdditionalInformationView({
      model: new Backbone.Model({
        awPackage,
        contractExtensionTypes,
        editable
      })
    });
  }
}
